<div class="documents--loading">
    <div >
        <div class="documents-loading icon rotate"></div>
        <span class="loading-text">Loading</span>
    </div>
</div>

<div class="cunstom-forms-bg"></div>